import store from "./store/index";
import * as msg from "./message";

export const error = (eData) => {
  let message = msg.INTERNAL_SERVER_ERROR;
  let buttonText = "Continue";
  let type = "logout";
  if (eData.status == 500) {
    store.state.notifications.showAlert.message = msg.INTERNAL_SERVER_ERROR;
    store.state.notifications.showAlert.type = "danger";
  } else if (eData.status == 404) {
  } else if (eData.status == 400) {
  } else if (eData.status == 422) {
    message = msg.INTERNAL_SERVER_ERROR;
    buttonText = "Continue";
    type = "";
  } else if (eData.status == 420 && eData.data.status == "negative_inventory") {
    store.state.notifications.messageBox.text =
      msg.INSUFFICIENT_INVENTORY_TITLE;
    store.state.notifications.messageBox.btnText = "Dismiss";
    store.state.notifications.messageBox.type = "";
    store.state.notifications.messageBox.info =
      msg.ORDER_INSUFFICIENT_INVENTORY;
    store.state.notifications.messageBox.open = true;
  } else {
    let errorData = eData.data;
    if (errorData.status == "licence_not_valid") {
      message = errorData.message;
      buttonText = "Logout";
      store.state.license = "";
    } else if (errorData.status == "licence_expired") {
      message = msg.LICENCE_EXPIRED;
      buttonText = "Logout";
    } else if (errorData.status == "redirect_to_store_list") {
      message = msg.LOGIN_REDIRECT;
      buttonText = "Logout";
    } else if (errorData.status == "day_settlement_done") {
      message = errorData.message;
      buttonText = "Logout";
    } else if (errorData.status == "stop_inventory_movement") {
      message = errorData.message;
      buttonText = "Dismiss";
      type = "";
    }
    store.state.notifications.message.text = message;
    store.state.notifications.message.btnText = buttonText;
    store.state.notifications.message.type = type;
  }
};

export const failAlert = (response) => {
  let url = JSON.parse(response.config.data).url;
  let blockList = ["/latest-invoice-id", "/oms/generate-invoice"];
  if (blockList.includes(url)) return;
  let alertData = {
    message: response.data.message,
    type: "danger",
  };
  store.commit("notifications/showAlert", alertData);
};
